import React from 'react'
import { FormattedMessage } from 'react-intl'

const menu = [
  {
    tab: 1,
    child: <FormattedMessage id="Profile" defaultMessage="Profile" />,
  },
  {
    tab: 2,
    child: <FormattedMessage id="Availability" defaultMessage="Availability" />,
  },
]

export default menu
